import styled from "@emotion/styled";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config";
import { WebcastEntry } from "@kaltura/mediaspace-shared-types";
import { getEntryUrl } from "@kaltura/mediaspace-shared-utils";
import { EventListItem } from "@kaltura/mediaspace-shared-event-platform-event-list";

export interface WebcastEntryWithWatchListStatus extends WebcastEntry {
    inWatchlist?: boolean; // isInWatchlist flag
}

export interface SessionsListProps {
    sessions?: WebcastEntryWithWatchListStatus[];
    disabledMode?: boolean;
    onToggleWatchList?: (id: string, add: boolean) => void;
    calendarEntriesToken?: string;
}

const StyledEventListItem = styled(EventListItem)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export function SessionsList({
    sessions = [],
    onToggleWatchList,
    disabledMode = false,
    calendarEntriesToken,
}: SessionsListProps) {
    const config = useConfig();
    const enableEntryTitles = config?.application?.enableEntryTitles;

    const goToEntryPage = (entryId: string, entryName: string | undefined) => {
        entryName = enableEntryTitles ? entryName : undefined;
        document.location.href = getEntryUrl(entryId, undefined, entryName);
    };

    return (
        <div>
            {sessions.map((session) => {
                return (
                    <StyledEventListItem
                        disabledMode={disabledMode}
                        data={session}
                        key={`scheduled-session_${session.id}`}
                        vodCallback={goToEntryPage}
                        liveCallback={goToEntryPage}
                        entryLink={getEntryUrl(session.id, undefined, enableEntryTitles ? session.name : undefined)}
                        inWatchlist={session.inWatchlist}
                        onToggleWatchList={onToggleWatchList}
                        calendarEntriesToken={calendarEntriesToken}
                    />
                );
            })}
        </div>
    );
}

export default SessionsList;
